import {useMemo} from 'react';
import {bindActionCreators} from '@reduxjs/toolkit';

import {useAppDispatch} from 'stores/redux_store';
import {changeThreadFollowOnServer} from 'features/threads/actions/change_thread_follow_on_server';
import {
    flagPost,
    markPostAsUnread,
    pinPost,
    setEditingPost,
    unflagPost,
    unpinPost,
} from 'actions/post_actions';
import {openModal} from 'actions/views/modals';
import {selectPost, selectPostFromRightHandSideSearch} from 'actions/views/rhs';
import {focusPostToEdit} from 'components/permalink_view/actions';

export function usePostMenuActions() {
    const dispatch = useAppDispatch();

    return useMemo(() => {
        return bindActionCreators({
            changeThreadFollowOnServer,
            flagPost,
            focusPostToEdit,
            markPostAsUnread,
            openModal,
            pinPost,
            setEditingPost,
            selectPost,
            selectPostFromRightHandSideSearch,
            unflagPost,
            unpinPost,
        }, dispatch);
    }, [dispatch]);
}
